import { gql } from "apollo-boost"

export const SUBMISSION_OBJECTIVE_WITH_SCHEDULES = gql`
  query submissionObjectivesWithSchedules($id: ID!) {
    submissionObjectivesWithSchedules(id: $id) {
      id
      allies
      alliedOne
      alliedTwo
      endDate
      startDate
      generalObjective
      developmentObjective
      reports {
          period
      }
      specificObjectives {
        id
        description
        orderIndex
        indicators {
          id
          isBlocking
          goal
          title
          formula
          baseline
          products
          orderIndex
          methodology
          description
          meansOfVerification
          meansOfVerificationPerMonth {
            id
            month
            year
            monthProgress
            excessProgress
          }
        }
        activities {
          id
          isBlocking
          goal
          title
          place
          inputs
          months
          formula
          baseline
          products
          orderIndex
          methodology
          description
          responsible
          meansOfVerification
          estimatedParticipants
          meansOfVerificationPerMonth {
            id
            month
            year
            monthProgress
            excessProgress
          }
          schedules {
            id
            place
            scheduledAt
            completedAt
            startTime
            endTime
          }
        }
      }
      generalObjectiveIndicators {
        id
        goal
        title
        formula
        baseline
        products
        description
        methodology
        meansOfVerification
        meansOfVerificationPerMonth {
          id
          month
          year
          monthProgress
          excessProgress
        }
      }
      developmentObjectiveIndicators {
        id
        goal
        title
        formula
        baseline
        products
        methodology
        description
        meansOfVerification
        meansOfVerificationPerMonth {
            id
            month
            year
            monthProgress
            excessProgress
        }
      }
       communicationObjectiveActivity
      {
        id
        goal
        title
        place
        inputs
        months
        formula
        baseline
        products
        orderIndex
        methodology
        description
        responsible
        meansOfVerification
        estimatedParticipants
        meansOfVerificationPerMonth {
          id
          month
          year
          monthProgress
          excessProgress
          }
          schedules {
            id
            place
            scheduledAt
            completedAt
            startTime
            endTime
          }
      }
    }
  }
`
